"use client";

import { TooltipProvider } from "@repo/design-system/components/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { bind, setEnabled } from "cuelume";
import { useEffect, type ReactNode } from "react";
import { Toaster } from "@/components/ui/toaster";
import { queryClient } from "@/lib/queryClient";

interface ProvidersProps {
  readonly children: ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  useEffect(() => {
    bind();

    const savedPreference = window.localStorage.getItem(
      "swansonking.interaction-sounds"
    );
    setEnabled(savedPreference !== "muted");
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delay={0}>
        {children}
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
};
